import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fontsource/ibm-plex-sans"
import "./src/styles/global.css"

import { MasterRefProvider } from './src/context/MasterRefContext'

export const wrapRootElement = ({ element }) => (
    <MasterRefProvider>{element}</MasterRefProvider>
)